import { ILogger } from "../../Commons/Logging/ILogger";
import { ChainableValueProducer } from "../../Commons/TasksCore/ChainableValueProducer";
import { reject } from "../../../../Common/TypingUtils";

import { AcquirePublishedEngineTask } from "./AcquirePublishedEngineTask";
import { EngineSource, getEngineSourceKey } from "./EngineSource";

const enginePool: { [key: string]: ChainableValueProducer<string> } = {};

export function engineFactory(
    source: EngineSource,
    candyModulesDirectory: string,
    useVersionFromCache: boolean,
    logger?: ILogger
): ChainableValueProducer<string> {
    const key = getEngineSourceKey(source);
    if (source.type === "LocalEngineSources") {
        throw new Error("MultipleSourceNotImplemented");
    }
    if (enginePool[key] == undefined) {
        enginePool[key] = new AcquirePublishedEngineTask(
            source.version,
            candyModulesDirectory,
            useVersionFromCache,
            logger
        );
    }
    return enginePool[key] ?? reject();
}
